import { useState } from "react";
import Sidebar from "../../../../components/dashboard/Sidebar";
import { setAlert } from "../../../../redux/actions/alert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
function DashboardShippingCreate({ setAlert }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    time_to_delivery: "",
  });

  const [errors, setErrors] = useState({});

  const { name, price, time_to_delivery } = formData;

  const validateForm = () => {
    const newErrors = {};
    if (!name) {
      newErrors.name = "El nombre es obligatorio.";
    } else if (name.length > 255) {
      newErrors.name = "El nombre no puede tener más de 255 caracteres.";
    }

    if (!price) {
      newErrors.price = "El precio es obligatorio.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(price) || parseFloat(price) <= 0) {
      newErrors.price = "Debe ser un número positivo con hasta dos decimales.";
    }

    if (!time_to_delivery) {
      newErrors.time_to_delivery = "El tiempo de entrega es obligatorio.";
    } else if (time_to_delivery.length > 255) {
      newErrors.time_to_delivery =
        "El tiempo de entrega no puede tener más de 255 caracteres.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `JWT ${localStorage.getItem("access")}`,
          Accept: "application/json",
        },
      };
      const formData = new FormData();
      formData.append("name", name);
      formData.append("price", price);
      formData.append("time_to_delivery", time_to_delivery);
      const fetchData = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/shipping/shipping/create/`,
            formData,
            config,
          );
          if (response.status === 201) {
            setAlert("Envío creado exitosamente", "green");
            navigate("/dashboard/shipping");
          }
        } catch (error) {
          if (
            error.response.status === 400 &&
            error.response.data.price.includes(
              "Asegúrese de que no haya más de 3 dígitos en la parte entera.",
            )
          ) {
            setAlert(
              "Asegúrese de que no haya más de 3 dígitos en la parte entera.",
              "red",
            );
          }
        }
      };
      fetchData();
    }
  };

  return (
    <Sidebar>
      <div className="container mx-auto px-4 sm:px-8">
        <h1 className="text-2xl font-semibold text-gray-900 mt-4">
          Crear Envío
        </h1>
        <div className="mt-8">
          <form onSubmit={handleSubmit} className="max-w-3xl mx-auto">
            <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Detalles del Envío
              </h3>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Nombre del Envío
              </label>
              <div className="mt-1 sm:mt-0 sm:col-span-2">
                <input
                  type="text"
                  name="name"
                  placeholder="Nombre del envío"
                  value={name}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />

                {errors.name && (
                  <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                )}
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
              <label
                htmlFor="price"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Precio
              </label>
              <div className="mt-1 sm:mt-0 sm:col-span-2">
                <input
                  type="number"
                  name="price"
                  placeholder="Precio del envío"
                  value={price}
                  onChange={onChange}
                  min={0}
                  step="0.01"
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />

                {errors.price && (
                  <p className="text-red-500 text-xs mt-1">{errors.price}</p>
                )}
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-2">
              <label
                htmlFor="time_to_delivery"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Tiempo de Entrega
              </label>
              <div className="mt-1 sm:mt-0 sm:col-span-2">
                <input
                  type="text"
                  name="time_to_delivery"
                  placeholder="Tiempo de entrega"
                  value={time_to_delivery}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />

                {errors.time_to_delivery && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.time_to_delivery}
                  </p>
                )}
              </div>
            </div>

            <button
              type="submit"
              className="inline-flex mt-4 float-right items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Crear Envío
            </button>
          </form>
        </div>
      </div>
    </Sidebar>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps, { setAlert })(DashboardShippingCreate);
